<div class="container" data-meta="subcat-list-container" aria-hidden="false">
  <mat-card appearance="outlined" data-section="subcat-list" data-random="sbc1">
    <mat-card-title data-element="subcat-title">Sub-Category List</mat-card-title>

    <!-- Add SubCategory Button -->
    <button
      style="position: absolute; right: 10px; top: 8px; width: 35px; height: 35px;"
      [ngClass]="isAdminGroupUser ? 'mat-mini-fab mat-accent' : 'mat-mini-fab mat-button-disabled'"
      color="accent"
      tabindex="0"
      matTooltip="Add Subcategory"
      (click)="onAddSubCategoryClick()"
      aria-label="Add SubCategory"
      mat-fab
      data-role="add-subcategory"
      data-extra="add-subcat-btn"
      [disabled]="isAdminGroupUser === false"
    >
      <span class="mat-mdc-button-wrapper" data-icon="add">
        <i class="material-icons" style="font-size: 30px" data-placeholder="plus">add</i>
      </span>
    </button>

    <!-- Download Subcategories Button -->
    <button
      style="position: absolute; right: 50px; top: 8px; width: 35px; height: 35px;"
      *ngIf="subcategoryWithCategories != null && subcategoryWithCategories.length > 0"
      (click)="onDownloadSubCategoriesClick()"
      color="accent"
      matTooltip="Download Records"
      aria-label="Download SubCategories"
      mat-fab
      data-role="download-subcategories"
      data-extra="download-subcat-btn"
    >
      <span class="mat-mdc-button-wrapper" data-icon="download">
        <i class="material-icons" style="font-size: 30px" data-placeholder="download">download</i>
      </span>
    </button>

    <mat-card-subtitle data-marker="subtitle"></mat-card-subtitle>

    <!-- Filter -->
    <div class="row" data-area="filters" aria-live="polite">
      <div class="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9" data-container="filter-left"></div>
      <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3" data-container="filter-right">
        <app-filter-input
          *ngIf="subcategoryWithCategories != null && subcategoryWithCategories.length > 0"
          (filterChanged)="applySubCategoryFilter($event)"
          data-component="filter-input"
        ></app-filter-input>
      </div>
    </div>

    <mat-card-content data-body="content-area">
      <div class="table-responsive" data-wrapper="table-area" aria-live="assertive">
        <table
          *ngIf="subcategoryWithCategories != null && subcategoryWithCategories.length > 0"
          mat-table
          [dataSource]="dataSource"
          matSort
          (matSortChange)="announceSubCategorySort($event)"
          class="mat-elevation-z8"
          aria-label="Table listing subcategories"
          data-table-id="subcat-table"
        >
          <!-- Serial Number -->
          <ng-container matColumnDef="icon">
            <th mat-header-cell *matHeaderCellDef data-header="serial">S No.</th>
            <td mat-cell *matCellDef="let element; let i = index" data-cell="serial">
              {{
                i + 1 + (pageEvent?.pageSize || paginator.pageSize) *
                (pageEvent?.pageIndex || paginator.pageIndex)
              }}
            </td>
          </ng-container>

          <!-- productId -->
          <ng-container matColumnDef="productId">
            <th mat-header-cell *matHeaderCellDef data-header="prod-id"></th>
            <td mat-cell *matCellDef="let element" data-cell="prod-id">{{ element.productId }}</td>
          </ng-container>

          <!-- productName -->
          <ng-container matColumnDef="productName">
            <th mat-header-cell *matHeaderCellDef data-header="prod-name">Product Name</th>
            <td mat-cell *matCellDef="let element" data-cell="prod-name">{{ element.productName }}</td>
          </ng-container>

          <!-- subCategoryId -->
          <ng-container matColumnDef="subCategoryId">
            <th mat-header-cell *matHeaderCellDef data-header="subcat-id"></th>
            <td mat-cell *matCellDef="let element" data-cell="subcat-id">{{ element.subCategoryId }}</td>
          </ng-container>

          <!-- categoryId -->
          <ng-container matColumnDef="categoryId">
            <th mat-header-cell *matHeaderCellDef data-header="cat-id"></th>
            <td mat-cell *matCellDef="let element" data-cell="cat-id">{{ element.categoryId }}</td>
          </ng-container>

          <!-- categoryName -->
          <ng-container matColumnDef="categoryName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by categoryName" data-header="cat-name">
              Category
            </th>
            <td mat-cell *matCellDef="let element" data-cell="cat-name">{{ element.categoryName }}</td>
          </ng-container>

          <!-- subCategoryName -->
          <ng-container matColumnDef="subCategoryName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by subCategoryName" data-header="subcat-name">
              SubCategory
            </th>
            <td mat-cell *matCellDef="let element" data-cell="subcat-name">{{ element.subCategoryName }}</td>
          </ng-container>

          <!-- description -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by description" data-header="description">
              Description
            </th>
            <td mat-cell *matCellDef="let element" data-cell="description">{{ element.description }}</td>
          </ng-container>

          <!-- isDeleted -->
          <ng-container matColumnDef="isDeleted">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by isDeleted" data-header="deleted">
              Deleted
            </th>
            <td mat-cell *matCellDef="let element" data-cell="deleted">{{ element.isDeleted }}</td>
          </ng-container>

          <!-- createdBy -->
          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef data-header="created-by">CreatedBy</th>
            <td mat-cell *matCellDef="let element" data-cell="created-by">{{ element.createdBy }}</td>
          </ng-container>

          <!-- createdOn -->
          <ng-container matColumnDef="createdOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by createdOn" data-header="created-on">
              createdOn
            </th>
            <td mat-cell *matCellDef="let element" data-cell="created-on">{{ element.createdOn }}</td>
          </ng-container>

          <!-- updatedBy -->
          <ng-container matColumnDef="updatedBy">
            <th mat-header-cell *matHeaderCellDef data-header="updated-by">UpdatedBy</th>
            <td mat-cell *matCellDef="let element" data-cell="updated-by">{{ element.updatedBy }}</td>
          </ng-container>

          <!-- updatedOn -->
          <ng-container matColumnDef="updatedOn">
            <th mat-header-cell *matHeaderCellDef data-header="updated-on">UpdatedOn</th>
            <td mat-cell *matCellDef="let element" data-cell="updated-on">{{ element.updatedOn }}</td>
          </ng-container>

          <!-- Edit -->
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef data-header="edit">Edit</th>
            <td mat-cell *matCellDef="let element" data-cell="edit">
              <button
                mat-mini-fab
                aria-label="Edit"
                [disabled]="!isAdminGroupUser"
                (click)="onEditSubCategory($event, element)"
                data-btn="edit-subcategory"
                data-extra="edit-subcat"
              >
                <mat-icon>create</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Delete -->
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef data-header="delete">Delete</th>
            <td mat-cell *matCellDef="let element" data-cell="delete">
              <button
                mat-mini-fab
                aria-label="Delete"
                color="warn"
                [disabled]="!isAdminGroupUser"
                (click)="onDeleteSubCategory($event, element)"
                data-btn="delete-subcategory"
                data-extra="delete-subcat"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" data-row="header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" data-row="data-row"></tr>
        </table>

        <!-- Paginator -->
        <mat-paginator
          [length]="totalRows"
          [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          (page)="pageEvent = $event; pageChanged($event)"
          data-element="paginator"
          data-meta="pagination-control"
        ></mat-paginator>

        <!-- Loader -->
        <div *ngIf="isLoaderResult" class="custSpinner" aria-busy="true" data-loader="true"></div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
